// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2pY1N","rootCenter":"LoadMoreObserver_rootCenter__2bn03","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1BBq_"};